"use client";

import { c as _c } from "react/compiler-runtime";
import { CenterAligned, classNames, FlexColumn, ImageStack, Spinner, TextBody, TextHeading, useIsLessThanLg } from "@opensea/ui-kit";
import { useWindowSize } from "@opensea/ui-kit/hooks";
import Confetti from "react-confetti";
import { createPortal } from "react-dom";
export function TransactionFullScreen(t0) {
  const $ = _c(29);
  const {
    confetti,
    title,
    body,
    images,
    loading,
    bottom,
    monochrome
  } = t0;
  const isMobile = useIsLessThanLg();
  const {
    width
  } = useWindowSize();
  let t1;
  if ($[0] !== confetti || $[1] !== width) {
    t1 = confetti ? createPortal(<div className="fixed top-0 left-0 z-modal h-screen w-screen" style={{
      pointerEvents: "none"
    }}><Confetti gravity={0.2} key={width} numberOfPieces={100} recycle={true} wind={0} /></div>, document.body) : null;
    $[0] = confetti;
    $[1] = width;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = monochrome ? "saturate-0" : "";
  let t3;
  if ($[3] !== t2) {
    t3 = classNames("relative z-50 py-10", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== images || $[6] !== isMobile || $[7] !== monochrome) {
    t4 = (images?.length || 0) > 0 && <ImageStack animate={monochrome ? undefined : "fade-in"} overrides={{
      animation: {
        position: {
          left: {
            className: "delay-400"
          },
          right: {
            className: "delay-200"
          }
        }
      }
    }} show={monochrome ?? true} size={isMobile ? 180 : 360} srcs={images?.map(_temp)} />;
    $[5] = images;
    $[6] = isMobile;
    $[7] = monochrome;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== title) {
    t5 = title ? <TextHeading size="lg"><h2>{title}</h2></TextHeading> : null;
    $[9] = title;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== body) {
    t6 = body ? <TextBody color="text-secondary">{body}</TextBody> : null;
    $[11] = body;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <FlexColumn className="gap-6">{t5}{t6}</FlexColumn>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== loading) {
    t8 = loading ? <FlexColumn><Spinner size="md" /></FlexColumn> : null;
    $[16] = loading;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== bottom || $[19] !== t4 || $[20] !== t7 || $[21] !== t8) {
    t9 = <FlexColumn className="items-center gap-4 text-center">{t4}{t7}{t8}{bottom}</FlexColumn>;
    $[18] = bottom;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t3 || $[24] !== t9) {
    t10 = <CenterAligned className={t3}>{t9}</CenterAligned>;
    $[23] = t3;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t1 || $[27] !== t10) {
    t11 = <>{t1}{t10}</>;
    $[26] = t1;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}
function _temp(image) {
  return image ?? undefined;
}